const PREFIX = "Shared/Role/";

export const RECEIVE_ROLES = `${PREFIX}RECEIVE_ROLES`;
